import { isMobile } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import Accordion, { ItemStatus } from '../../../ReactComponents/Accordion/Accordion';
import AccordionItem from '../../../ReactComponents/Accordion/AccordionItem';
import { FilterOptionViewModel } from '../FilterOptionViewModel.csharp';
import { FilterViewModel } from '../FilterViewModel.csharp';
import { CategoriesTreeCategory } from './CategoriesTreeCategory';

interface CategoriesTreeProps {
    container: HTMLDivElement | null;
    categoryFilters: FilterViewModel;
    onChangeOption: (
        filterKey: string,
        subfilterKey: string | null,
        optionKey: string,
        isSelected: boolean,
        isSubfilter?: boolean,
        callback?: () => void
    ) => void;
    isProductsLoading?: boolean;
}

export const CategoriesTree = ({ categoryFilters, onChangeOption, container, isProductsLoading }: CategoriesTreeProps) => {
    const isProductsLoadingPrevious = useRef(isProductsLoading);

    const isCategoryActive = (category: FilterOptionViewModel): boolean => {
        return category.isSelected || category.children.some((x) => x.isSelected);
    };

    const buildStatus = () => {
        return categoryFilters.options.map((category) => {
            return { isActive: isCategoryActive(category), isExpanded: false };
        });
    };

    const [itemsStatus, setItemsStatus] = React.useState<ItemStatus[]>(buildStatus());

    const [activeItemsStatus, setActiveItemsStatus] = React.useState<ItemStatus[]>(itemsStatus);

    useEffect(() => {
        setActiveItemsStatus(itemsStatus);
    }, [categoryFilters]);

    useEffect(() => {
        if (isProductsLoading && !isProductsLoadingPrevious.current) {
            setItemsStatus(buildStatus());
        }
        isProductsLoadingPrevious.current = isProductsLoading;
    }, [isProductsLoading]);

    const handleOnClick = (option: FilterOptionViewModel, e: HTMLButtonElement | null) => {
        const scrollDelay = 1;

        onChangeOption(categoryFilters.key, null, option.key, true, false, () => {
            setTimeout(() => {
                if (isMobile() && e && container) {
                    container.scrollTo({ top: e.offsetTop, behavior: 'smooth' });
                }
            }, scrollDelay);
        });
    };

    return (
        <div className="Form__FieldList CategoriesTree">
            <Accordion
                labelClassName="CategoriesTree__CategoryHeading"
                itemClassName="CategoriesTree__Category"
                itemsStatus={activeItemsStatus}
                onActiveItemChanged={setItemsStatus}
            >
                {categoryFilters.options.map((option) =>
                    option.count > 0 ? (
                        <AccordionItem
                            key={option.key}
                            label={`${option.value} (${option.count})`}
                            onClick={(e) => handleOnClick(option, e)}
                            className={classNames(isCategoryActive(option) && 'CategoriesTree__CategoryHeading--Active')}
                        >
                            <CategoriesTreeCategory key={option.key} category={option} onChangeOption={onChangeOption} categoryKey={categoryFilters.key} />
                        </AccordionItem>
                    ) : null
                )}
            </Accordion>
        </div>
    );
};
